
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRealtimeTags } from 'Core/hooks';
import { useIntl } from 'react-intl';
// Components
import { Loading } from "@gpstrackit/gtc-react-controls";

// Actions
import { getAsset } from './redux/slice'
import { TagsGroup } from "Components/Tag";
const AssetInfo = (props) => {
    const { openTooltip, assetId, assetName } = props
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const [currentTags, setCurrentTags] = useState([]);

    // Redux States
    const loading = useSelector((state) => state.driverPerformanceEventsTabAssetInfoRedux.loading);
    const asset = useSelector((state) => state.driverPerformanceEventsTabAssetInfoRedux.asset);
    const tags = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags'] });

    useEffect(() => {
        if (openTooltip && assetId) {
            dispatch(getAsset({ id: assetId }))
        }
    }, [openTooltip])

    useEffect(() => {
        if (asset) {
            let tagIds = asset?.asset?.tagIds || [];
            let current = [];

            if (tagIds === "[-99]") {
                current = tags;
            } else {
                tags?.forEach((tag) => {
                    if (tagIds?.includes(tag?.id)) {
                        current.push(tag);
                    }
                });
            }
            setCurrentTags(current)
        }
    }, [asset, tags])

    return (
        <div style={{ minHeight: 45, width: 249 }}>
            {
                loading ? <div><Loading full /></div > :
                    <>
                        {
                            asset?.asset ? (
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', height: 25 }}>
                                        <strong style={{ marginRight: 5 }}>{messages['driver_performance_events_asset_id']}:</strong><p>{asset?.id}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 20 }}>
                                        <strong style={{ marginRight: 5, flexShrink: 0 }}>{messages['driver_performance_events_asset_name']}:</strong><p style={{ wordBreak: 'break-word', overflowWrap: 'break-word', margin: 0, flex: 1, minWidth: 0 }}>{asset?.label}</p>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', height: 25 }}>
                                        <strong style={{ marginRight: 5 }}>{messages['driver_performance_events_driver_tags']}:</strong>
                                        {
                                            currentTags?.length > 0 ? (
                                                <TagsGroup
                                                    options={currentTags || []}
                                                    nameField="label"
                                                    colorField="color"
                                                />
                                            ) : (
                                                <div>N/A</div>
                                            )
                                        }
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {
                                        assetName ? (
                                            <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 20 }}>
                                                <strong style={{ marginRight: 5, flexShrink: 0 }}>{messages['driver_performance_events_asset_name']}:</strong><p style={{ wordBreak: 'break-word', overflowWrap: 'break-word', margin: 0, flex: 1, minWidth: 0 }}>{assetName}</p>
                                            </div>
                                        ) : (
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 45 }}>{messages['driver_performance_events_asset_no_asset_info']}</div>
                                        )
                                    }
                                    {!assetName && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 45 }}>{messages['driver_performance_events_asset_no_asset_info']}</div>}
                                </>
                            )
                        }
                    </>
            }
        </div>
    )

}

export default AssetInfo;
